import React from 'react';
import PropTypes from 'prop-types';
import { P, Link } from 'components/Typography';
import { isEmpty } from 'ramda';
import { UserInfoCard, Row, CardContainer } from './styled';
import EditableInput from '../EditableInput';

const UserInfo = ({ formik, onSave, loadingField, activeProducts }) => {
  const userInfoCardVariants = {
    finish: {
      y: 0,
      opacity: 1,
      transition: {
        y: {
          type: 'spring',
          damping: 300,
          delay: 0.4
        },
        opacity: { delay: 0.4 }
      }
    },
    start: {
      y: 20,
      opacity: 0
    }
  };

  if (isEmpty(activeProducts)) {
    return null;
  }

  return (
    <CardContainer variants={userInfoCardVariants} animate="finish" initial="start">
      <UserInfoCard variants={userInfoCardVariants} animate="finish" initial="start">
        <Row>
          <P>Date of birth</P>
          <EditableInput
            formik={formik}
            name="dateOfBirth"
            type="date"
            onSave={onSave}
            loadingField={loadingField}
          />
        </Row>
        <Row>
          <P>Gender</P>
          <EditableInput
            formik={formik}
            name="gender"
            type="gender"
            onSave={onSave}
            loadingField={loadingField}
          />
        </Row>
        <Row>
          <P>Email address</P>
          <EditableInput
            formik={formik}
            name="email"
            type="text"
            onSave={onSave}
            loadingField={loadingField}
          />
        </Row>
        <Row>
          <P>Password</P>
          <Link to={`/forgot-password?email=${formik?.values?.email}`}>
            Reset password
          </Link>
        </Row>
      </UserInfoCard>
    </CardContainer>
  );
};

UserInfo.propTypes = {
  formik: PropTypes.object,
  onSave: PropTypes.func,
  loadingField: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  activeProducts: PropTypes.array
};

export default UserInfo;
